<template>
  <div class="main-body">
    <div class="header">打卡记录</div>
    <div class="out">
      <div class="search2">

          <div style="float:right">

            <el-select v-model="governmentCode" placeholder="请选择政府"
                       style="margin-right:10px">
              <el-option
                  v-for="item in governmentValue"
                  :key="item.governmentCode"
                  :label="item.name"
                  :value="item.governmentCode">
              </el-option>
            </el-select>

            <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px;">
              <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
              <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
            </el-input>

            <el-button type="primary" size="mini" plain @click="getList(true)">搜索</el-button>
          </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="elderly.name" label="老人姓名" width="85"></el-table-column>
        <el-table-column prop="elderly.idCard" label="身份证号" width="200"></el-table-column>
        <el-table-column prop="elderly.phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="elderly.zoneName" label="所属区域" width="300"></el-table-column>
        <el-table-column prop="serve.name" label="服务人员"  width="85"></el-table-column>
        <el-table-column label="拍照图片" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" title="" trigger="click" v-if="scope.row.imgUrl">
              <img :src="imgUrl+scope.row.imgUrl+'_watermark.jpg'"  style="width: 500px"/>
              <img slot="reference" :src="imgUrl+scope.row.imgUrl+'_watermark.jpg'" style="width:100%">
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="打卡地址" width="200" ></el-table-column>
        <el-table-column prop="remark" label="备注" width="200"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

      <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Elderly from "@/views/Elderly/Comm/ElderlyGov2";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalGetElderly:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      imgUrl:this.$imgUrl,


      th:0,

      userCode: "",
      elderlyCode:'',
      userName:'',
      imeiAll: "",

      governmentValue: [],
      governmentCode: '',

    }
  },
  components:{
    Elderly
  },
  created(){

    this.getGovList();

    this.th = this.$store.state.tableHeight;

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },



    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.governmentCode);
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.elderlyCode = '';
      this.userName = '';
    },


    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1


      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyClockin/AdmPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: this.governmentCode,
          elderlyCode: this.elderlyCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,

        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        console.log(error);
      });
    },





  }
}
</script>

<style scoped>

</style>
